import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { theme } from '../../../../../domain/theme';
import { SmartLink } from '../../../../SmartLink';
import { NatGeoLogoText } from '../../../atoms/NatGeoLogoText';
import { NatGeoLogoImage } from '../../../atoms/NatGeoLogoImage';
import { eventService } from '../../../../../domain/services/eventService';

export const LogoMenuItem = ({ content }) => {
  const [isBranded, setIsBranded] = useState(content?.branded);
  const onTransporterRoutePreUpdate = event => {
    setIsBranded(event.detail.content?.branded);
  };
  useEffect(() => {
    eventService.addEventListener(
      'transporterRoutePreUpdate',
      onTransporterRoutePreUpdate,
      { addFlag: false }
    );

    return () =>
      eventService.removeEventListener(
        'transporterRoutePreUpdate',
        onTransporterRoutePreUpdate
      );
  }, []);
  const showH1 = !['article', 'photo_gallery', 'show'].includes(
    content?.bundle
  );
  const showContentTitle = ['hub_page'].includes(content?.bundle) && !isBranded;

  const styles = {
    logoImage: css`
      a {
        display: block;
        margin-left: ${theme.spacing('xs')};
        ${theme.mq.tablet} {
          margin-left: ${theme.spacing('s')};
        }
      }
      svg {
        display: block;
      }
    `,
    logoText: css`
      min-width: ${showContentTitle ? 150 : 95}px;
      margin-left: ${showContentTitle ? 12 : 5}px;
      ${theme.font.family('boldWeb')};
      font-size: ${theme.font.size('s')};
      line-height: initial;
      letter-spacing: ${theme.letterSpacing('base')};
      text-transform: uppercase;
      color: #000;
      a {
        display: block;
        color: inherit;
        height: ${showContentTitle ? 'auto' : '26px'};
      }
      svg {
        height: 26px;
      }
      h1 {
        font-size: inherit;
        font-weight: unset;
        margin: 0;
        padding: 0;
      }
      ${theme.mq.tablet} {
        font-size: ${theme.font.size('base')};
      }
    `,
    brandedText: css`
      max-width: 100px;
      padding-left: ${theme.spacing('xs')};
      border-left: 1px solid #000;
      ${theme.font.family('regularWeb')};
      font-weight: ${theme.font.weight('l')};
      font-size: 13px;
      line-height: initial;
      letter-spacing: ${theme.letterSpacing('base')};
      text-transform: uppercase;
      color: #000;
      a {
        color: inherit;
      }
      & span {
        ${theme.font.family('boldWeb')};
      }
    `,

    hidden: css`
      display: none;
    `
  };

  let logoText;
  if (showContentTitle) {
    logoText = showH1 ? <h1>{content.title}</h1> : content.title;
  } else {
    logoText = (
      <>
        <span css={styles.hidden} title="National Geographic">
          {showH1 ? <h1>National Geographic</h1> : 'National Geographic'}
        </span>
        <NatGeoLogoText />
      </>
    );
  }
  return (
    <>
      <div css={styles.logoImage}>
        <SmartLink to="/" title="National Geographic">
          <NatGeoLogoImage width={21} />
        </SmartLink>
      </div>
      <div css={styles.logoText}>
        <SmartLink to="/">{logoText}</SmartLink>
      </div>
      {isBranded ? (
        <div css={styles.brandedText}>
          <SmartLink to="/">
            Creative <span>Works</span>
          </SmartLink>
        </div>
      ) : null}
    </>
  );
};

LogoMenuItem.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired
};
